import { Component, EventEmitter, Input, Output } from '@angular/core';
import { List as ImmutableList, List } from 'immutable';
import {
    dreamTeamsRoutePath,
    dreamTeamsSelfServeRoutePath,
    RoleType
} from '../../constants-types';
import { Group, IconType, GroupUpdate } from '../../core-data-model';
import { IconSize } from '../../core-data-model/IconSize';
import { GroupsDataService } from '../../core-services';
import { DateFormatUtility, Util } from '../../core-utilities';
import { InitDataService } from '../../system-services';
import { TranslationService } from '../../translations';

@Component({
    selector: 'group-card',
    template: `
        <div
            class="roundedBoxContainer__sessionsCard sessionsCard flex-display"
        >
            <div
                class="sessionsCard"
                [ngClass]="{
                    'color-neutral-600': isHiddenGroup()
                }"
            >
                <div class="layoutHorizontal">
                    <ng-content select="scoreArea"></ng-content>
                    <div class="layoutVertical">
                        <div class="sessionsCard__title">
                            {{ group.name }}
                        </div>
                        <div
                            class="layout--center layoutFixedHorizontalSmallSpacing"
                            style="padding: 0 0 25px 25px;"
                        >
                            @if (isSharedGroup() && !selfServe) {
                                <div class="title-sm color-primary">
                                    {{ TR.key('sharedGroups.sharedWithMe') }}
                                </div>
                            }
                            @if (isMyGroup()) {
                                <div class="title-sm color-person">
                                    {{ TR.key('sharedGroups.createdByMe') }}
                                </div>
                            }
                            @if (
                                isHiddenGroup() || (!isMyGroup() && selfServe)
                            ) {
                                <div class="title-sm">
                                    {{ getCreateByText() }}
                                </div>
                            }
                            <div class="copy-sm">
                                {{ TR.key('teamworkgraph.teamsection-title') }}:
                                {{ group.peopleAndJobCount }}
                            </div>
                            <div class="copy-sm">
                                {{
                                    TR.key(
                                        'label.assessment.openinvitation.lastmodified'
                                    )
                                }}:
                                {{ dateUtil.transformDate(group.modifiedTime) }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex-display" style="padding-right: 25px;">
                <div
                    style="padding-right: 15px; align-self: center;"
                    tooltip
                    [tooltipContent]="TR.key('groupCard.whyDisabled.tooltip')"
                    tooltipPlacement="bottom"
                    [tooltipDisabled]="!isHiddenGroup()"
                >
                    @if (showTeamDiscoveryCTA()) {
                        <button
                            class="button button-tertiary button-sm"
                            [routerLink]="getTeamDiscoveryLink()"
                            [disabled]="isHiddenGroup()"
                        >
                            {{ groupService.getTDSessionStatusText(group) }}
                        </button>
                    }
                </div>
                <div
                    tooltip
                    [tooltipContent]="TR.key('groupCard.whyDisabled.tooltip')"
                    tooltipPlacement="bottom"
                    [tooltipDisabled]="!isHiddenGroup()"
                >
                    @if (!selfServe) {
                        <div
                            data-testing="groupCardButtonForMoreOptions"
                            style="display: block;"
                            class="button button-circle"
                            (click)="expandOptions()"
                            (clickOutside)="focusLost()"
                            [ngClass]="{
                                'disable-interaction': isHiddenGroup()
                            }"
                            [attr.disabled]="isHiddenGroup() ? '' : null"
                        >
                            <span
                                class="dotsContainer"
                                style="padding: 2px 0px 0px 2px"
                                ><svg
                                    width="20"
                                    height="17"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g
                                        transform="translate(.977 .627)"
                                        fill="#3D1C70"
                                        fill-rule="evenodd"
                                    >
                                        <circle
                                            cy="1.771"
                                            cx="1.771"
                                            r="1.771"
                                        />
                                        <circle
                                            cy="1.771"
                                            cx="7.97"
                                            r="1.771"
                                        />
                                        <circle
                                            cy="1.771"
                                            cx="14.169"
                                            r="1.771"
                                        />
                                    </g>
                                </svg>
                            </span>
                            @if (showGroupOptions) {
                                <div class="groupOptionContent">
                                    @if (!isTeamDiscovery) {
                                        <div
                                            data-testing="viewTeamDetails"
                                            [routerLink]="
                                                getTeamLink(isTeamDiscovery)
                                            "
                                            class="layoutDefault"
                                            style="margin-bottom: 10px; align-items: center;"
                                        >
                                            <span
                                                class="button button-circle"
                                                style="width:22px; height:22px"
                                            >
                                                <abstract-icon
                                                    style="display:flex; font-size:12px;"
                                                    [iconType]="
                                                        IconType.TeamDetails
                                                    "
                                                    [iconSize]="IconSize.Small"
                                                ></abstract-icon>
                                            </span>
                                            <span class="groupOptionText">
                                                {{ TR.key('team.viewDetails') }}
                                            </span>
                                        </div>
                                    }
                                    @if (userCanEdit()) {
                                        <div
                                            data-testing="editTeam"
                                            (click)="openEditPanel()"
                                            class="layoutDefault"
                                            style="margin-bottom: 10px; align-items: center;"
                                        >
                                            <span
                                                class="button button-circle"
                                                style="width:22px; height:22px"
                                            >
                                                <abstract-icon
                                                    style="display:flex; font-size:12px;"
                                                    [iconType]="IconType.Edit"
                                                    [iconSize]="IconSize.Small"
                                                ></abstract-icon>
                                            </span>
                                            <span class="groupOptionText">{{
                                                TR.key(
                                                    'label.myTeams.edit-team-header'
                                                )
                                            }}</span>
                                        </div>
                                    }
                                    @if (userCanOpenShare()) {
                                        <div
                                            (click)="showSharePanel = true"
                                            class="layoutDefault"
                                            style="align-items: center;"
                                        >
                                            <span
                                                class="button button-circle"
                                                style="width:22px; height:22px"
                                            >
                                                <abstract-icon
                                                    style="font-size:12px;"
                                                    [iconType]="
                                                        IconType.BentArrow
                                                    "
                                                    [iconSize]="IconSize.Small"
                                                ></abstract-icon>
                                            </span>
                                            <span class="groupOptionText">{{
                                                TR.key('teams.shareTeam')
                                            }}</span>
                                        </div>
                                    }
                                    @if (group.hasTeamDiscoverySession) {
                                        <div
                                            class="layoutDefault"
                                            style="align-items: center; margin-top: 10px;"
                                            (click)="getTeamSummaryLink()"
                                        >
                                            <span
                                                class="button button-circle"
                                                style="width:22px; height:22px"
                                            >
                                                <abstract-icon
                                                    style="font-size:12px;"
                                                    [iconType]="
                                                        IconType.LearnNew
                                                    "
                                                    [iconSize]="IconSize.Small"
                                                ></abstract-icon>
                                            </span>
                                            <span class="groupOptionText">
                                                {{
                                                    TR.key(
                                                        'groupCard.viewTeamSummary'
                                                    )
                                                }}
                                            </span>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
        </div>
        <peek-panel [open]="showEditPanel" (close)="showEditPanel = false">
            @if (showEditPanel || showGroupOptions) {
                <group-edit
                    [myGroup]="group"
                    [groupSet]="editContents"
                    style="display: inline-block; flex:1"
                    (groupChanged)="reloadGroupData()"
                    (cancel)="showEditPanel = false"
                    (saveHit)="showEditPanel = false"
                    (groupPeopleCount)="groupPeopleCount.emit()"
                    (optionalQuestionAnswered)="optionalQuestionAnswered.emit()"
                ></group-edit>
            }
        </peek-panel>
        <peek-panel [open]="showSharePanel" (close)="shareClosed()">
            @if (isShareReady()) {
                <team-share
                    style="width: 585px"
                    [myGroup]="group"
                    (close)="shareClosed()"
                    (groupUpdated)="groupUpdated($event)"
                >
                </team-share>
            }
        </peek-panel>
    `,
    styles: [
        `
            .groupOptionContent {
                padding: 10px;
                position: relative;
                background-color: #ffffff;
                min-width: 190px;
                box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
                z-index: 1;
                right: 150px;
            }

            .groupOptionText {
                margin-left: 10px;
                font-size: 14px;
                font-weight: 400;
            }

            .dotsContainer {
                cursor: pointer;
                height: 38px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        `
    ],
    standalone: false
})
export class GroupCardComponent {
    IconType = IconType;

    groupFilter: string;

    @Input()
    group: Group;
    @Input()
    isTeamDiscovery = false;

    @Input()
    selfServe = false;

    @Input()
    isLegacyWithDesign2 = false;

    @Input()
    canEdit = false;

    @Output()
    groupPeopleCount = new EventEmitter<void>();

    @Output()
    optionalQuestionAnswered = new EventEmitter<void>();

    editContents: List<any> = ImmutableList();
    showEditPanel = false;
    showSharePanel: boolean;
    showGroupOptions: boolean;

    IconSize = IconSize;

    constructor(
        public TR: TranslationService,
        private init: InitDataService,
        public groupService: GroupsDataService,
        public dateUtil: DateFormatUtility,
        public util: Util
    ) {}

    // Card is in charge of keeping its group data updated
    async reloadGroupData() {
        this.group = this.groupService.getGroup(this.group.id);
    }

    shareClosed() {
        this.showSharePanel = false;
    }

    async groupUpdated(event: GroupUpdate): Promise<void> {
        await this.groupService.updateGroup(event);
        this.reloadGroupData();
    }

    isMyGroup(): boolean {
        return (
            this.group.groupOwnerId === this.init.user.userGuid &&
            !this.group.isHidden
        );
    }

    isSharedGroup(): boolean {
        return (
            this.group.groupOwnerId !== this.init.user.userGuid &&
            !this.group.isHidden
        );
    }

    isHiddenGroup(): boolean {
        return this.group.isHidden;
    }

    getCreateByText(): string {
        return this.util.strings.formatString(
            this.TR.key('createdBy'),
            this.group.groupOwner.getPartialDisplayName()
        );
    }

    getTeamLink(isInTeamDiscovery: boolean) {
        if (isInTeamDiscovery) {
            return `/groups/${this.group.id}`;
        }
        return `${this.group.id}`;
    }

    getTeamDiscoveryLink(): string {
        let sessionLink = '';
        if (this.isLegacyWithDesign2) {
            // WHEN ABAC ONLY 2.0 Ready transition this to /session and pull session id
            sessionLink = `/design/team/${this.group.id}`;
        } else if (this.selfServe) {
            sessionLink = `/design/${dreamTeamsSelfServeRoutePath}/${this.group.id}`;
        } else {
            sessionLink = `/design/${dreamTeamsRoutePath}/${this.group.id}`;
        }
        return sessionLink;
    }

    showTeamDiscoveryCTA() {
        return this.groupService.showTeamDiscovery(this.group) || this.canEdit;
    }

    userCanEdit() {
        return this.groupService.isEditableByUser(this.group);
    }

    userCanOpenShare() {
        return (
            this.userCanEdit() &&
            this.init.hasPermissionLevelOrAbove(RoleType.User)
        );
    }

    isShareReady() {
        return (
            (this.showGroupOptions || this.showSharePanel) && this.userCanEdit()
        );
    }

    async openEditPanel() {
        this.editContents = ImmutableList(
            await this.groupService.getGroupContentsByGroup(this.group)
        );

        this.showEditPanel = true;
    }

    focusLost() {
        this.showGroupOptions = false;
    }

    expandOptions() {
        this.showGroupOptions = !this.showGroupOptions;
    }

    getTeamSummaryLink() {
        window.open(
            // there’s is no route for a selfServe team summary report since it’s the same as teamDiscovery's
            `/design/${dreamTeamsRoutePath}/${this.group.id}/teamSummary`,
            '_blank'
        );
    }
}
